export type SchedulerStatus = 'running' | 'stopped' | 'error' | 'offline';

export type ReminderCronHealth = {
  cronName: string;
  schedulerStatus: SchedulerStatus;
  cronEnabled: boolean;
  lastHeartbeatAt: string | null;
  nextReminderDueAt: string | null;
  lastReminderProcessedAt: string | null;
  totalRemindersProcessedToday: number;
  pendingReminderCount: number;
  lastErrorMessage: string | null;
  updatedAt: string | null;
};

export const SCHEDULER_STATUS_LABELS: Record<SchedulerStatus, string> = {
  running: 'Running',
  stopped: 'Stopped',
  error: 'Error',
  offline: 'Offline',
};

export function schedulerStatusBadgeVariant(
  status: SchedulerStatus,
): 'published' | 'draft' | 'danger' {
  if (status === 'running') {
    return 'published';
  }
  return 'danger';
}
